import { isApiMocksEnabled } from '../../apiMocks/apiMocksEnabled';

import * as realKeycloakAuth from './keycloakAuth';

type AuthModule = Pick<
  typeof realKeycloakAuth,
  'getAccessToken' | 'initKeycloak' | 'isImpersonatedSession' | 'keycloakLogout' | 'keycloakLogin'
>;

let authModule: AuthModule = realKeycloakAuth;

export async function initAuth(dispatch: Parameters<AuthModule['initKeycloak']>[0]) {
  if (isApiMocksEnabled) {
    authModule = await import('./mockKeycloakAuth');
  }

  authModule.initKeycloak(dispatch);
}

export function getAccessToken() {
  return authModule.getAccessToken();
}

export function isImpersonatedSession() {
  return authModule.isImpersonatedSession();
}

export function keycloakLogout() {
  return authModule.keycloakLogout();
}

export function keycloakLogin() {
  return authModule.keycloakLogin();
}
